import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_auth/dashboard/organizations/$organizationId/settings/',
)({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <div>Hello "/_auth/dashboard/organizations/$organizationId/settings/"!</div>
    );
}
